import { createAsyncThunk } from '@reduxjs/toolkit';
import { SocialPostService } from '../../services/SocialPostService';

export const fetchPosts = createAsyncThunk(
  'socialPosts/fetchPosts',
  async (params = {}, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.getPosts(params);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const fetchPostById = createAsyncThunk(
  'socialPosts/fetchPostById',
  async (postId, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.getPostById(postId);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const createPost = createAsyncThunk(
  'socialPosts/createPost',
  async (postData, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.createPost(postData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const updatePost = createAsyncThunk(
  'socialPosts/updatePost',
  async ({ postId, updateData }, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.updatePost(postId, updateData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const deletePost = createAsyncThunk(
  'socialPosts/deletePost',
  async (postId, { rejectWithValue }) => {
    try {
      await SocialPostService.deletePost(postId);
      return postId;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const submitForApproval = createAsyncThunk(
  'socialPosts/submitForApproval',
  async (postId, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.submitForApproval(postId);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const approvePost = createAsyncThunk(
  'socialPosts/approvePost',
  async (postId, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.approvePost(postId);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const rejectPost = createAsyncThunk(
  'socialPosts/rejectPost',
  async ({ postId, note }, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.rejectPost(postId, note);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const queuePost = createAsyncThunk(
  'socialPosts/queuePost',
  async ({ postId, scheduled_at }, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.queuePost(postId, scheduled_at);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const cancelPost = createAsyncThunk(
  'socialPosts/cancelPost',
  async (postId, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.cancelPost(postId);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const retryPost = createAsyncThunk(
  'socialPosts/retryPost',
  async (postId, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.retryPost(postId);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);

export const fetchStats = createAsyncThunk(
  'socialPosts/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const data = await SocialPostService.getStats();
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);
